import { SmartDataTable } from '@src/components/SmartDataTable';
import { useOfferingsColumns, useOfferingsFormFields, useOfferingsCardView } from './hooks';

export const OfferingsList = () => {
  const columns = useOfferingsColumns();
  const formFields = useOfferingsFormFields();
  const { OfferingsCardView } = useOfferingsCardView();
  return (
    <SmartDataTable
      api={{
        resource: 'offerings',
      }}
      title="Offerings"
      columns={columns}
      search={{
        enabled: true,
        fields: ['name', 'search_term'],
        placeholder: 'Search by offering name...',
        debounceMs: 500,
      }}
      createForm={{
        fields: formFields as any,
        title: 'Create Offering',
        submitText: 'Create Offering',
      }}
      editForm={{
        fields: formFields as any,
        title: 'Edit Offering',
        submitText: 'Save Changes',
      }}
      formDisplayMode="modal"
      showCreate={true}
      showEdit={true}
      showDelete={true}
      showView={false}
      actionWidth={100}
      pageSize={10}
      showSizeChanger={true}
      showQuickJumper={false}
      // showExport={true}
      showColumnVisibility={true}
      tableProps={{
        scroll: {
          x: 'max-content',
          y: 'calc(100vh - 240px)',
        },
      }}
      rowKey="id"
      mobileCardComponent={OfferingsCardView}
    />
  );
};
